/**
 * Cloudflare 云端适配器 — 对接 Pages Functions API
 * 适配器契约：{ save(key, data) → Promise<void>, load(key) → Promise<?> }
 * 与 localStorage 适配器同接口，setAdapter() 后其余代码一行不改。
 *
 * 数据以整份 JSON 存 D1（user_data.data），带 updatedAt 乐观锁。
 */
import { getSessionUser } from '../modules/auth.js';

// API 路径使用字面量 /api（避免 esbuild 惰性初始化时序问题）

function getToken() {
  const session = getSessionUser();
  return (session && session.token) || null;
}

function getDataKey() {
  // 云端按 userId 隔离，key 仅作冗余标识（实际以 token 鉴权）
  const session = getSessionUser();
  if (session && session.email) {
    return 'competitorTracker_' + session.email.replace(/[^a-zA-Z0-9@._-]/g, '');
  }
  return 'competitorTracker';
}

export const CloudflareAdapter = {
  save(key, data) {
    const token = getToken();
    if (!token) return Promise.reject(new Error('未登录，无法云端同步'));

    return fetch('/api/data', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        data: data,
        updatedAt: (data && data.updatedAt) || Date.now()
      })
    }).then(function(res) {
      if (res.status === 409) {
        return res.json().then(function(body) {
          throw new Error(body.message || '云端数据已被更新，请刷新后重试');
        });
      }
      if (!res.ok) throw new Error('云端保存失败 (' + res.status + ')');
      return res.json();
    }).then(function(body) {
      if (body && body.updatedAt && data) data.updatedAt = body.updatedAt;
    });
  },

  load(key) {
    const token = getToken();
    if (!token) return Promise.resolve(null);

    return fetch('/api/data', {
      method: 'GET',
      headers: { 'Authorization': 'Bearer ' + token }
    }).then(function(res) {
      if (res.status === 401) return null;
      if (!res.ok) throw new Error('云端拉取失败 (' + res.status + ')');
      return res.json();
    }).then(function(body) {
      // 回填 updatedAt，保证刷新后乐观锁（409 冲突检测）仍有效
      if (body && body.data) {
        if (body.updatedAt) body.data.updatedAt = body.updatedAt;
        return body.data;
      }
      return null;
    });
  }
};
